<template>
  <el-select
    v-model="dataValue"
    style="width: 100%;"
    clearable=""
    placeholder="请选择品类">
    <el-option
      v-for="item in listNew"
      :key="item.categoryId"
      :label="item.categoryName"
      :value="item.categoryId">
    </el-option>
  </el-select>
</template>
<script>
import Appraise from '@/service/appraise'
export default {
  name: 'CategorySelect',
  props: {
    exclude: { type: Array, default() { return [] } },
    value: { type: [Number, String] }
  },
  data() {
    return { list: [] }
  },
  computed: {
    listNew({ list, exclude }) {
      return list.filter(i => !exclude.includes(i.categoryId))
    },
    dataValue: {
      get: function() {
        return this.value
      },
      set: function(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      Appraise.getappraisalcategorys({ pageNum: 1, pageSize: 100 })
        .then(res => {
          const { result, message, records } = res.data
          if ([0, 13].includes(result)) {
            this.list = records.map(i => ({ categoryId: i.id, categoryName: i.categoryName }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    }
  }
}
</script>
